
import React from "react";
import { Schemes, Utils } from "../../../../../../../utils";
import { i18nManager } from "../../../../../../../i18n";
import { Elements } from "../../../../../../shared/Elements";
import { Siren } from "../../../../../../shared/ConfirmDialog";
import * as ReactRouterDom from "react-router-dom";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, IMember, IProfileWebsite, IHost, MemberService, SanitizedResponse, IHostWebsite, HostService, ITournamentEdition, ITournamentEditionWebsite, TournamentService } from "../../../../../../../services";
import { Button, ButtonManageRef, Checkbox, ComposedPassword, DOMHelper, Dropdown, Form, FormControl, NoseurObject, ObjectHelper, TabPane, TabPanel, TextAreaInput, TextInput } from "@rivtn/noseur";
import ImportExport from "../../../../../../page_design/ImportExport";
import MediaInput, { MediaInputManageRef } from "../../../../../../shared/MediaInput";

export interface SocialNetworksProps {
    profile: IMember;
    tournamentEdition: ITournamentEdition;
    tournamentEditionWebsite: ITournamentEditionWebsite;
}

function SocialNetworks(props: SocialNetworksProps) {

    const { tournamentEdition } = props;
    const tournamentService = TournamentService.getInstance();
    const [profile, _] = React.useState<IMember>(props.profile);
    const labels = i18nManager.Labels.host.manage_tournament.settings.general.social_networks;
    if (!props.tournamentEditionWebsite.social_accounts) props.tournamentEditionWebsite.social_accounts = {};

    return (<div style={{ marginTop: 10, display: "flex", flexDirection: "column" }}>
        <span>{labels.enter_tour_usernames}</span>
        {Object.keys(i18nManager.Labels.account.manage_account.social_accounts.accounts_keys).map((accounts_key: string) => (<FormControl key={accounts_key} isFieldset fill style={{ maxWidth: 600, marginTop: 15 }}
            label={(i18nManager.Labels.account.manage_account.social_accounts.accounts_keys as any)[accounts_key]}>
            <TextInput defaultValue={props.tournamentEditionWebsite.social_accounts?.[accounts_key]}
                onInputComplete={(value) => props.tournamentEditionWebsite.social_accounts[accounts_key] = value} />
        </FormControl>))}
        <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save_changes}
            style={{ marginTop: 30, padding: "10px 25px", alignSelf: "flex-end" }} onClick={(e) => updateHostSocialAccounts(e.manageRef)} />
    </div>);

    function updateHostSocialAccounts(manageRef?: ButtonManageRef) {
        manageRef?.setLoadingState(true);
        tournamentService.updateTournamentEditionWebsite(tournamentEdition.external_id, props.tournamentEditionWebsite).then(({ sanitized }: SanitizedResponse<ITournamentEditionWebsite>) => {
            props.tournamentEditionWebsite.social_accounts = sanitized.social_accounts;
            Siren.alert(labels.update_success);
        }).catch(BaseService.reportError).finally(() => manageRef?.setLoadingState(false));
    }

}

export default SocialNetworks;
